// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2mrfe","row":"styles_row__2HaCf","extraInformation":"styles_extraInformation__ZrLJ4","studentId":"styles_studentId__9TZx7"};